import { Component, EventEmitter, OnInit, Output, ViewChild, OnDestroy } from '@angular/core';
import { CustomField } from '../custom-field/custom-field-model';
import { NgForm } from '@angular/forms';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { SubSink } from 'subsink';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
declare var $: any;
declare var Toast: any;

@Component({
  selector: 'custom-field-edit',
  templateUrl: './custom-field-edit.component.html',
  styleUrls: ['./custom-field-edit.component.css']
})

export class CustomFieldEditComponent implements OnInit, OnDestroy {
  private customField: CustomField = new CustomField();
  private isNew: boolean = true;
  private modal: any;
  private subs = new SubSink();

  @ViewChild('editForm', { static: false }) editForm: NgForm;

  @Output()
  private saved: EventEmitter<CustomField> = new EventEmitter<CustomField>();

  constructor(private repository: HttpRepositoryService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modal = $('#customFieldForm');
  }

  public show(customField: CustomField, isNew: boolean) {
    this.editForm.reset();
    this.customField = customField;
    this.isNew = isNew;

    this.modal.modal({
      show: true,
      backdrop: 'static',
      keyboard: false
    });
  }

  private save() {
    if (this.editForm.valid) {

      if (this.isNew)
        this.insert();
      else
        this.update();

    } else {
      Object.keys(this.editForm.controls)
        .forEach(fieldName => {
          this.editForm.controls[fieldName].markAsDirty();
        });
      $('#name').focus();
    }
  }

  private insert(): void {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Insert custom field', 'error');
      } else {
        this.subs.sink = this.repository.post<CustomField>('api/CustomField/Create', this.customField, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Create custom field', 'error');
          } else {
            Toast.Show('Custom field created successfully.', 'Create custom field', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private update(): void {
    this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
      if (afResp.hasErrors) {
        Toast.Show(afResp.error, 'Update custom field', 'error');
      } else {
        this.subs.sink = this.repository.put<CustomField>('api/CustomField/Edit', this.customField, afResp.data).subscribe(resp => {
          if (resp.hasErrors) {
            Toast.Show(resp.error, 'Update custom field', 'error');
          } else {
            Toast.Show('Custom field updated successfully.', 'Update custom field', 'success');
          }

          this.onSaveCompleted(resp.data);
        });
      }
    });
  }

  private onSaveCompleted(data: CustomField) {
    this.close();
    this.saved.emit(data);
  }

  close() {
    this.modal.modal('hide');
    this.customField = new CustomField();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
